import { INITIAL_F2F_FORM_OPTIONS } from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/initial-f2f/initial-f2f-form-options-constant";
import { EncounterSumaryFormTypeEnum } from "@/services";
import { TenantFeature } from "./tenant-feature-constant";

export type DefaultForm = {
  name: string;
  value: EncounterSumaryFormTypeEnum;
  feature?: TenantFeature;
};

export const DEFAULT_FORM_LIST: DefaultForm[] = [
  { name: "Simple SOAP Note", value: "SIMPLE_SOAP_NOTE" },
  { name: "Primary Care SOAP Note", value: "PRIMARY_CARE_SOAP_NOTE" },
  { name: "Psychiatric Note", value: "PSYCHIATRIC_NOTE" },
  // { name: "Treatment Plan", value: "TREATMENT_PLAN" },
  // { name: "Pre-Operative Note", value: "PREOPERATIVE_NOTE" },
  {
    name: "Initial Psychiatric Evaluation",
    value: "INITIAL_PSYCHOTHERAPY",
  },
  // { name: "Free SOAP Note", value: "FREE_SOAP_NOTE" },
  // { name: "Psychodynamic Therapy", value: "PSYCHODYNAMIC_THERAPY_NOTE" }, // ECRH-5045: hidden from dropdown; available under Individual psychotherapy note
  { name: "Psychotherapy Note", value: "PSYCHOTHERAPY_NOTE" },
  // { name: "Individual Therapy Note", value: "INDIVIDUAL_THERAPY_NOTE" },
  { name: "Psychoeducation Therapy", value: "PSYCHOEDUCATION_THERAPY" },
  { name: "Collaborative Care Model", value: "COLLABORATIVE_CARE_MODEL" },
  { name: "Psychiatric Progress Exam", value: "PSYCHIATRIC_PROGRESS" },
  { name: "DAP Note", value: "DAP_NOTE" },
  { name: "BIRP Note", value: "BIRP_NOTE" },
  { name: "Progress Note", value: "PROGRESS_NOTE" },
  ...INITIAL_F2F_FORM_OPTIONS,
];

export const DEFAULT_VISIT_NOTE_FORM_TYPE: EncounterSumaryFormTypeEnum =
  EncounterSumaryFormTypeEnum.PsychiatricNote;

export const PREMIER_MD_DEFAULT_VISIT_NOTE_FORM_TYPE: EncounterSumaryFormTypeEnum =
  EncounterSumaryFormTypeEnum.PremierMdInitialF2F;
